/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useEffect, useState } from "react";

//DataGrid
import DataGridBkitb from "../../components/PantallesBKI/DataGridMui/DataGrid";
import { columnsProperties } from "../../components/PantallesBKI/DataGridMui/Columns/Columns";
import { CustomLoadingOverlay } from "../../components/PantallesBKI/DataGridMui/Loading/Loading";

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

/*  COLORES */
import { colorVerdFosc, colorVermellFosc } from "../../constants/Colors";

/*ICONOS*/
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";

/*MENSAJES DE ALERTA*/
import ErrorAlert from "../../components/PantallesBKI/Alertas/ErrorAlert";
import AlertDelete from "../../components/PantallesBKI/Alertas/AlertDelete";
import InsertAlert from "../../components/PantallesBKI/Alertas/InsertAlert";

import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";

/* COMPONENTES MUI */
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import { URL_BKI, apiUrl, APP_JSON } from "../../constants/URL";

import { getAuthToken } from "../../security/tokenUtils";

//Estilos MODAL
const styleModal = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function TablaPropertiesView() {
  const [token] = useState(getAuthToken());

  //Modal
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  //Variables de edicion
  const [grup, setGrup] = React.useState([]);
  const [clau, setClau] = React.useState([]);
  const [valor, setValor] = React.useState([]);

  //Variables de edición Modal
  const [isEditing, setIsEditing] = useState(false);

  //Funciones para activar o desactivar la edición de los campos
  const handleStartEditing = () => {
    setIsEditing(true);
  };
  const handleStopEditing = () => {
    setIsEditing(false);
  };
  //Estado para escoger accion a realizar en la base de datos
  const [option, setOption] = React.useState([""]);

  const [selectionModel, setSelectionModel] = React.useState([]);

  //Estado del spinner
  const [isLoading, setIsLoading] = useState(true);

  /*Control de cambios en los valores de los inputs*/
  const handleChangeId = (event) => {
    setGrup(event.target.value);
  };
  const handleChangeComponente = (event) => {
    setClau(event.target.value);
  };
  const handleChangeAutor = (event) => {
    setValor(event.target.value);
  };

  function accionRow(action) {
    if (action === "desar") {
      setOption("desar");
    } else if (action === "insertar") {
      //1r Limpiamos los campos
      setGrup("");
      setClau("");
      setValor("");
      //2n Pasamos la opcion que queremos hacer
      setOption("insertar");
    } else {
      throw new Error("Unexpected value for action");
    }

    handleOpen(); //abrimos modal
  }

  function mostraForm() {
    const row = selectedRows[0];

    if (selectionModel.length > 0) {
      setGrup(row.GRUP);
      setClau(row.CLAU);
      setValor(row.VALOR);
      handleStopEditing();
    } else {
      handleStartEditing();
      setGrup("");
      setClau("");
      setValor("");
    }
  }
  useEffect(() => {
    mostraForm();
  }, [selectedRows]);

  function CustomToolbar(props) {
    return (
      <GridToolbarContainer {...props} className="customToolBar">
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <Button
          variant="contained"
          sx={colorVerdFosc}
          startIcon={<EditIcon />}
          size="small"
          onClick={() => accionRow("desar")}
          disabled={selectionModel.length === 0}
          style={{ marginLeft: 16 }}
        >
          Editar
        </Button>
        <Button
          variant="contained"
          type="submit"
          startIcon={<DeleteIcon />}
          onClick={() => AlertDelete(clau, postData, "eliminar")}
          size="small"
          disabled={selectionModel.length === 0}
          sx={colorVermellFosc}
        >
          Eliminar
        </Button>
        <Button
          variant="contained"
          sx={colorVerdFosc}
          startIcon={<AddCircleIcon />}
          size="small"
          disabled={selectionModel.length === 1}
          onClick={() => accionRow("insertar")}
        >
          NOVA ENTRADA
        </Button>
      </GridToolbarContainer>
    );
  }

  const getData = async () => {
    await fetch(URL_BKI.GET_PROPIETATS, {
      headers: {
        "Content-Type": APP_JSON,
        Authorization: `Bearer ${token}`,
        Accept: APP_JSON,
      },
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        setData(myJson);
        setIsLoading(false);
      })
      .catch((error) => {
        ErrorAlert("ERROR al recuperar les dades: " + error, 10000);
        setIsLoading(false);
      });
  };

  const postData = async (accion) => {
    await fetch(apiUrl() + URL_BKI.POST_PROPIETATS, {
      method: "post",
      headers: {
        Accept: APP_JSON,
        "Content-Type": APP_JSON,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        GRUP: grup,
        CLAU: clau,
        VALOR: valor,
        ACCION: accion,
      }),
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(myJson) {
        if (myJson === 1) {
          switch (accion) {
            case "desar":
              InsertAlert("Dades actualitzades correctament");
              break;
            case "eliminar":
              InsertAlert("Dades eliminades correctament");
              break;
            case "insertar":
              InsertAlert("Dades agregades correctament");
              break;
            default:
              ErrorAlert("ERROR");
              break;
          }
          getData();
        } else {
          ErrorAlert("ERROR");
        }
      })
      .catch((error) => {
        ErrorAlert("Error " + error.message);
      });

    setOpen(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="boxPantalla">
      <div>
        <Modal
          sx={{
            width: "60%",
            margin: "150px auto",
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleModal} className="modal-edicio">
            <TextField
              id="outlined-basic"
              sx={{
                width: "70%",
              }}
              name="grup"
              label="GRUP"
              value={grup}
              onChange={handleChangeId}
              variant="outlined"
              disabled={!isEditing}
            />

            <TextField
              id="outlined-basic"
              label="CLAU"
              sx={{
                width: "70%",
              }}
              name="clau"
              value={clau}
              onChange={handleChangeComponente}
              variant="outlined"
              disabled={!isEditing}
            />

            <TextField
              id="outlined-basic"
              name="valor"
              multiline
              rows={2}
              sx={{
                width: "70%",
              }}
              label="VALOR"
              value={valor}
              onChange={handleChangeAutor}
              variant="outlined"
            />

            <div className="btn-edicio">
              <Button
                variant="contained"
                type="submit"
                onClick={() => postData(option)}
                startIcon={<SaveIcon />}
                sx={colorVerdFosc}
              >
                Desar
              </Button>

              <Button
                variant="contained"
                startIcon={<CancelIcon />}
                onClick={handleClose}
                color="inherit"
              >
                Cancelar
              </Button>
            </div>
          </Box>
        </Modal>
      </div>

      <h2>Taula de propietats</h2>

      <DataGridBkitb
        ampleTaula="90%"
        data={data}
        checkboxSelection={true}
        col={columnsProperties}
        components={{
          Toolbar: CustomToolbar,
          LoadingOverlay: CustomLoadingOverlay,
        }}
        getRowId={(row) => `${row.CLAU}_${row.GRUP}`}
        selectionModel={selectionModel}
        onSelectionModelChange={(selection) => {
          const selectedIDs = [...new Set(selection)]; //Obtengo el campo CLAU y GRUP seleccionado

          if (selection.length > 1) {
            //Comparo si he seleccionado otro valor anteriormente para hacer el cambio

            const selectionSet = new Set(selectionModel); //obtenemos el valor anterior
            const result = selection.filter((s) => !selectionSet.has(s)); //comprobamos si es diferente el valor seleccionado al anterior, y si es así lo cambiamos
            setSelectionModel(result);
            setSelectedRows(
              data.filter((row) => result.includes(`${row.CLAU}_${row.GRUP}`))
            ); //Filtramos a partir del nuevo campo seleccionado al origen de datos
          } else {
            const getSelectedRows = data.filter((row) =>
              selectedIDs.includes(`${row.CLAU}_${row.GRUP}`)
            ); //Busco en el origen de datos a partir del valor seleccionado

            setSelectedRows(getSelectedRows); //Asigno los valores obtenidos
            setSelectionModel(selection); //Guardo la CLAU actual seleccionada
          }
        }}
        loading={isLoading}
      />
    </div>
  );
}

export default TablaPropertiesView;
